import './index.scss';
import Skeleton  from '@mui/material/Skeleton';


const ShoppingBagItemSkeleton = () => {
    const windowWidth = window.innerWidth;
    return (
        <div className="shopping-bag__item">
            <div className="row">
                <div className="product-image">
                    <Skeleton animation="wave" className="shopping-bag__item-image" variant="rectangular"/>
                </div>
                <div className="product-detail">
                    <Skeleton animation="wave" variant="rounded" />
                    <br />
                    <Skeleton animation="wave" variant="rounded" height={75}/>
                    {windowWidth > 1023 && (
                        <>
                            <br />
                            <Skeleton animation="wave" variant="rounded" height={90} />
                        </>
                    )}
                </div>
            </div>
            <br />
            {windowWidth < 1023 && (
                <Skeleton animation="wave" variant="rounded" height={80}/>
            )}
        </div>
    );
};

export const ShoppingBagSkeleton = () => {
    return (                 
        <div className="slab slab--reverse">
            <div className="shopping-bag shoppingBagSkeleton">
                <div className="row gutter-30">
                    <div className="col-sm-6 col-md-7 col-lg-8 below-24">
                        <div className="row">
                            <div className="col-sm-6 col-md-7 col-lg-8">
                                <div className="padded-right">
                                    <h1 className="checkout-title title-underline">
                                        <Skeleton animation={'wave'}    variant="text" width={300}/>
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div className="padded-right">
                            {ShoppingBagItemSkeleton()}
                        </div>
                        <br />
                        <div className="padded-right">
                            {ShoppingBagItemSkeleton()}
                        </div>
                    </div>
                    
                    <div className="col-sm-6 col-md-5 col-lg-4"> 
                        <div className="summary-order__shopping-bag">
                            <div className="summary-order__title">
                                <h2 className="mega">
                                    <Skeleton animation={'wave'}    variant='text'/>
                                </h2>
                            </div>
                            <div>
                                <h2 className="mega">
                                    <Skeleton animation={'wave'}    variant='text' />
                                </h2>
                            </div> 
                            <div>
                                <h2 className="mega">
                                    <Skeleton animation={'wave'}    variant='text' />
                                </h2>
                            </div> 
                            <div>
                                <h2 className="mega">
                                    <Skeleton animation={'wave'}    variant='text' />
                                </h2>
                            </div>                

                            <div className="summary-order__discount-voucher">                                             
                                <Skeleton animation={'wave'}    variant='rounded' height={50} />
                            </div>

                            <div className="top-8">   
                                <div className="summary-order__discount-voucher discount-skele-border">                                             
                                    <Skeleton animation={'wave'}    variant='rounded' height={50} />
                                </div>                         
                            </div>

                            <div className="summary-order__discount-voucher">                                             
                                <Skeleton animation={'wave'}    variant='rounded' height={64} style={{ borderRadius: '1000px' }}/>
                            </div>

                            <div className="text-center top-16">
                                <a href="/#" className="link--underline">
                                    <Skeleton animation={'wave'} height={30} variant='text' />
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}